<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            <h3>Erstelle deinen Account</h3>
          </div>
          <form v-on:submit.prevent="checkForm">
            <base-input addon-left-icon="ni ni-email-83"
                        class="input-group-alternative mb-3"
                        placeholder="Email"
                        v-model="model.email">
            </base-input>

            <base-input addon-left-icon="ni ni-lock-circle-open"
                        class="input-group-alternative"
                        placeholder="Password"
                        type="password"
                        v-model="model.password">
            </base-input>

            <base-input addon-left-icon="ni ni-lock-circle-open"
                        class="input-group-alternative"
                        placeholder="Password"
                        type="password"
                        v-model="model.passwordAgain">
            </base-input>

            <div class="text-center">
              <base-button native-type="submit" type="primary">Account erstellen</base-button>
            </div>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <router-link class="text-light" to="/login">
            <small>Anmelden</small>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import firebase from "firebase";
  import 'firebase/firestore'

  export default {
    name: 'register',
    data() {
      return {
        model: {
          email: '',
          password: '',
          passwordAgain: '',
          emailValid: null,
          passwordValid: null,
          error: false,
        },
        studio: ''
      }
    },
    methods: {
      checkForm: function (e) {
        if (!this.model.password) {
          this.model.passwordValid = false;
        } else {
          this.model.passwordValid = true;
        }
        if (!this.model.email) {
          this.model.emailValid = false;
        } else this.model.emailValid = this.validEmail(this.model.email);

        if (this.model.emailValid && this.model.passwordValid) {
          firebase.auth().createUserWithEmailAndPassword(this.model.email, this.model.password).then(() => {
            const isAuthenticated = firebase.auth().currentUser;

            firebase.firestore().collection("users").doc(isAuthenticated.uid).set({
              uid: isAuthenticated.uid,
              is_admin: false,
              email: this.model.email,
              firstname: '',
              lastname: '',
              image: 'https://firebasestorage.googleapis.com/v0/b/next-level-studios-fe397.appspot.com/o/default.png?alt=media&token=86b6643b-f72a-455c-ad77-3ed0be56bff8'
            })
              .then(() => {
                var studioRef = firebase.firestore().collection("studios").doc(this.studio);

                return studioRef.update({
                  user_id: isAuthenticated.uid,
                  verified: true,
                  verification_key: ''
                })
                  .then(() => {
                    this.$router.push({ name: "dashboard" });
                  })
                  .catch(function (error) {
                    // The document probably doesn't exist.
                    // eslint-disable-next-line no-console
                    console.error("Error updating document: ", error);
                  });
              })
              .catch(function (error) {
                // eslint-disable-next-line no-console
                console.error("Error writing document: ", error);
              });
          })
            .catch(error => {
              this.error = error;
            });
        }

        e.preventDefault();
      },
      validEmail: function (email) {
        // eslint-disable-next-line no-useless-escape
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
        return re.test(email);
      }
    },
    created() {
      if (this.$route.params.verification_key) {
        firebase.firestore().collection("studios").where("verification_key", "==", this.$route.params.verification_key).get()
          .then((querySnapshot) => {
            if (querySnapshot.docs.length <= 0) {
              this.$router.push({ name: 'dashboard' })
            } else {
              this.studio = querySnapshot.docs[0].id
            }
          })
          .catch(function () {
            this.$router.push({ name: 'dashboard' })
          });
      } else {
        this.$router.push({ name: 'dashboard' })
      }
    }
  }
</script>
<style>
</style>
